import "core-js/modules/es.array.concat.js";
import './index.less';
var content = null;

var PayMaskTip = function () {
  function PayMaskTip() {
    this.body = document.body;
  }

  PayMaskTip.prototype.getTemplate = function () {
    return "<main class='j-pay-mask-tip-container'>\n    <p>\n      <span>\u8FDB\u884C\u5728\u7EBF\u4ED8\u6B3E</span>\n      <img src=".concat(require('@/assets/images/guide-arrow@2x.png'), " alt=\"\" />\n    </p>\n    <p>\n    \u70B9\u51FB\u5C4F\u5E55\u53F3\u4E0A\u89D2\n      <img src=").concat(require('@/assets/images/wx-right-top-btn@2x.png'), " alt=\"\" />\n      \u9009\u62E9\u6D4F\u89C8\u5668\u6253\u5F00\u672C\u9875\n    </p>\n  </main>\n  ");
  };

  PayMaskTip.prototype.show = function (_a) {
    var _this = this;

    var onClick = _a.onClick;
    content = document.createElement('div');
    content.innerHTML = this.getTemplate();
    content.id = 'j-pay-mask-tip';
    this.body.appendChild(content);
    var $el = document.getElementById('j-pay-mask-tip');

    if ($el) {
      $el.onclick = function () {
        if (onClick) {
          onClick();
        }

        _this.hide();
      };
    }
  };

  PayMaskTip.prototype.hide = function () {
    if (content) {
      this.body.removeChild(content);
    }
  };

  return PayMaskTip;
}();

export default new PayMaskTip();